import type { SVGProps } from 'react';

const SvgFilter7 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M3 5H1v18h18v-2H3zm20-4H5v18h18zm-2 16H7V3h14zm-8-2 4-8V5h-6v2h4l-4 8z" />
  </svg>
);
export default SvgFilter7;
